import type { ButtonHTMLAttributes } from 'react';

interface OptionCardProps {
  selected: boolean;
  onSelect: () => void;
  title: string;
  description: string;
  disabled?: boolean;
  /** Roving-tabindex radio semantics from the parent radiogroup (role, aria-checked, tabIndex,
   * data-radio-value, onKeyDown) — spread onto the button so keyboard arrow navigation works. */
  groupProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

export function OptionCard({ selected, onSelect, title, description, disabled, groupProps }: OptionCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      aria-disabled={disabled}
      className={`flex w-full flex-col gap-1 rounded-lg border p-3 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
        selected ? 'border-primary bg-secondary ring-1 ring-primary' : 'border-border bg-card hover:border-primary/30'
      }`}
      {...groupProps}
    >
      <span className="text-sm font-medium text-foreground">{title}</span>
      <span className="text-xs text-muted-foreground">{description}</span>
    </button>
  );
}
